import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ServicesGridTurnkeyRenovations from "./sections/ServicesGridTurnkeyRenovations";
import DemolitionServices from "./sections/DemolitionServices";
import ServicesGridAusbauarbeiten from "./sections/ServicesGridAusbauarbeiten";
import ServicesGridFliesenPlattenUndMosaikleger from "./sections/ServicesGridFliesenPlattenUndMosaikleger";
import FlooringServicesGrid from "./sections/FlooringServicesGrid";
import ServicesGridTrockenbauarbeiten from "./sections/ServicesGridTrockenbauarbeiten";
import ServicesGridVerputzarbeiten from "./sections/ServicesGridVerputzarbeiten";
import ServicesGridDachausbau from "./sections/ServicesGridDachausbau";
import ServicesGridClearance from "./sections/ServicesGridClearance";
import ServicesGridHausmeisterservice from "./sections/ServicesGridHausmeisterservice";
import PartnersSection from "./sections/PartnersSection";
import CallToActionSection from "./sections/CallToActionSection";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <HeroSection />
      <ServicesGridTurnkeyRenovations />
      <DemolitionServices />
      <ServicesGridAusbauarbeiten />
      <ServicesGridFliesenPlattenUndMosaikleger />
      <FlooringServicesGrid />
      <ServicesGridTrockenbauarbeiten />
      <ServicesGridVerputzarbeiten />
      <ServicesGridDachausbau />
      <ServicesGridClearance />
      <PartnersSection />
      <ServicesGridHausmeisterservice />
      <CallToActionSection />
      <Footer />
    </div>;
}